import script from "./PDFViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./PDFViewer.vue?vue&type=script&setup=true&lang=js"

import "./PDFViewer.vue?vue&type=style&index=0&id=0eb8dd8a&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0eb8dd8a"]])

export default __exports__